import { observer } from 'mobx-react';
import Modal from '../../../../../../Modal';
import { T } from '../../../../../../../Translations';
import { LearningDesignSection } from '../../../../Types';
import Form from './Form';
import { CloseAction, OpenableState } from '../../../../../../Modal/UseOpenable';
import LearningCollectionEditStore from '../../../../Edit/Store';

interface Props {
  modalState: OpenableState;
  close: CloseAction;
  section: LearningDesignSection;
  store: LearningCollectionEditStore;
}

function LearningDesignDetailsModal({ close, modalState, section, store }: Props) {
  switch (modalState.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={close}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          additionalClasses="overflow-visible"
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Edit Section Details" />
            </h3>
          }
        >
          <Form section={section} close={close} store={store} />
        </Modal>
      );
  }
}

export default observer(LearningDesignDetailsModal);
